import { CONTENT_PAGES } from './generated/pages'

/** Fill once per page at go-live, using actual publication/review timestamps with timezone.
 * No build-time dates: unset preview dates stay absent in both copy and JSON-LD.
 */
export interface ContentDates {
  datePublished?: string
  dateModified?: string
  lastReviewed?: string
}
/** Owner-authorized first publication, 2026-10-14, São Paulo timezone. Fixed, never build time. */
export const GO_LIVE_DATE = '2026-10-14'
export const GO_LIVE_TIMESTAMP = '2026-10-14T00:00:00-03:00'
export const GO_LIVE_DATES: Required<ContentDates> = {
  datePublished: GO_LIVE_TIMESTAMP,
  dateModified: GO_LIVE_TIMESTAMP,
  lastReviewed: GO_LIVE_TIMESTAMP
}
export const CONTENT_DATES: Partial<Record<string, ContentDates>> = Object.fromEntries(
  Object.keys(CONTENT_PAGES).map((slug) => [slug, { ...GO_LIVE_DATES }])
)

export const formatContentDate = (date: string): string =>
  new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo' }).format(new Date(date))
